import { store } from 'App';
import { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { authActions } from 'state/auth/auth.actions';
import { message } from 'antd';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export const useIdleDetector = (idleTime = 1200) => {
  const idleTimeout = 1000 * idleTime;
  const [isIdle, setIdle] = useState(false);
  const intlMessage = useFormatMessage();

  const handleIdle = () => {
    setIdle(true);
    store.dispatch(authActions.logout());
    message.warning(intlMessage({ id: 'auth.haveBeenLoggedOutInfo' }), 30);
  };
  const idleTimer = useIdleTimer({
    timeout: idleTimeout,
    onIdle: handleIdle,
    debounce: 500,
  });
  return {
    isIdle,
    setIdle,
    idleTimer,
  };
};
